var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonDetails(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.59199V11.4003C1.5 13.167 1.5 13.167 3.16667 14.292L7.75 16.942C8.44167 17.342 9.56667 17.342 10.25 16.942L14.8333 14.292C16.5 13.167 16.5 13.167 16.5 11.4087V6.59199C16.5 4.83366 16.5 4.83366 14.8333 3.70866L10.25 1.05866C9.56667 0.658659 8.44167 0.658659 7.75 1.05866L3.16667 3.70866C1.5 4.83366 1.5 4.83366 1.5 6.59199Z",
    stroke: "#1670D3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.4999C9.66304 11.4999 10.2989 11.2365 10.7678 10.7676C11.2366 10.2988 11.5 9.66291 11.5 8.99987C11.5 8.33683 11.2366 7.70094 10.7678 7.2321C10.2989 6.76326 9.66304 6.49987 9 6.49987C8.33696 6.49987 7.70107 6.76326 7.23223 7.2321C6.76339 7.70094 6.5 8.33683 6.5 8.99987C6.5 9.66291 6.76339 10.2988 7.23223 10.7676C7.70107 11.2365 8.33696 11.4999 9 11.4999Z",
    stroke: "#1670D3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonDetails);
export default __webpack_public_path__ + "static/media/button-details.dee29edc09419ddc1bf6395031f70866.svg";
export { ForwardRef as ReactComponent };